import React from 'react'
import { ViewPropTypes } from 'react-native'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import SelectInput from '../SelectInput'
import { initSelector } from '../../redux/initReducer/initSelector'

const EquipmentsSelectInput = ({ style, ...props }) => {
  const { loadingEquipmentTypes, equipmentTypes } = useSelector(initSelector)

  return (
    <SelectInput
      icon='Tractors'
      placeholder='Equipment type'
      keyProp='equipment_code'
      nameProp='description'
      options={equipmentTypes}
      loading={loadingEquipmentTypes}
      containerStyle={style}
      {...props}
    />
  )
}

EquipmentsSelectInput.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.any,
  onChange: PropTypes.func,
  multiselect: PropTypes.bool,
  style: ViewPropTypes.style,
  label: PropTypes.string,
  testID: PropTypes.string
}

EquipmentsSelectInput.defaultProps = {
  name: '',
  selected: null,
  icon: '',
  onChange: () => {},
  multiselect: false,
  testID: 'equipmentType'
}

export default EquipmentsSelectInput
